/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaveRequestUsageCalculation } from './LeaveRequestUsageCalculation';
import {
    LeaveRequestUsageCalculationFromJSON,
    LeaveRequestUsageCalculationFromJSONTyped,
    LeaveRequestUsageCalculationToJSON,
    LeaveRequestUsageCalculationToJSONTyped,
} from './LeaveRequestUsageCalculation';

/**
 * 
 * @export
 * @interface CreateLeaveRequestUsageCalculationResponse
 */
export interface CreateLeaveRequestUsageCalculationResponse {
    /**
     * 
     * @type {LeaveRequestUsageCalculation}
     * @memberof CreateLeaveRequestUsageCalculationResponse
     */
    data: LeaveRequestUsageCalculation;
}

/**
 * Check if a given object implements the CreateLeaveRequestUsageCalculationResponse interface.
 */
export function instanceOfCreateLeaveRequestUsageCalculationResponse(value: object): value is CreateLeaveRequestUsageCalculationResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateLeaveRequestUsageCalculationResponseFromJSON(json: any): CreateLeaveRequestUsageCalculationResponse {
    return CreateLeaveRequestUsageCalculationResponseFromJSONTyped(json, false);
}

export function CreateLeaveRequestUsageCalculationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeaveRequestUsageCalculationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LeaveRequestUsageCalculationFromJSON(json['data']),
    };
}

  export function CreateLeaveRequestUsageCalculationResponseToJSON(json: any): CreateLeaveRequestUsageCalculationResponse {
      return CreateLeaveRequestUsageCalculationResponseToJSONTyped(json, false);
  }

  export function CreateLeaveRequestUsageCalculationResponseToJSONTyped(value?: CreateLeaveRequestUsageCalculationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeaveRequestUsageCalculationToJSON(value['data']),
    };
}

